import { Link } from "react-router-dom";
import "../../assets/styles/components/Breadcrumb/Breadcrumbs.css";
import { ChevronRight } from "lucide-react";

const Breadcrumbs = ({ paths = [] }) => {
  return (
    <nav className="breadcrumb-wrapper">
      <Link to="/" className="breadcrumb-item" title="Home">Home</Link>
      {paths.map((item, index) => {
        return (
          <span key={index} className="breadcrumb-segment">
            <span className="breadcrumb-separator">
              <ChevronRight size={20} />
            </span>
            {!item.to ? (
              <span className="breadcrumb-item active">{item.label}</span>
            ) : (
              <Link to={item.to} className="breadcrumb-item">
                {item.label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
};

export default Breadcrumbs;
